<body>
  
</body>

<footer>
  <div class="container">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="text mt-4 mb-3">
        <p>جميع الحقوق محفوظة لدى خَيْرُكُمْ. 2021 &copy;</p>
      </div>                
    </div>
  </div>
</footer>